import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-logoPurple p-4">
      <div className="relative flex items-center">
        {/* Logo / Brand - Left */}
        <div className="flex items-center flex-shrink-0">
          <Link to="/" className="flex items-center">
            <h1 className="text-page text-2xl font-bold">
              Jack Reid
            </h1>
          </Link>
        </div>

        {/* Centered Nav Links - Desktop */}
        <ul className="absolute left-1/2 -translate-x-1/2 hidden md:flex space-x-12 list-none">
          <li>
            <Link to="/" className="text-page hover:text-gray-300">
              Home
            </Link>
          </li>
          <li>
            <Link to="/archive" className="text-page hover:text-gray-300">
              Portfolio
            </Link>
          </li>
          <li>
            <Link to="/research" className="text-page hover:text-gray-300">
              Research
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-page hover:text-gray-300">
              Contact
            </Link>
          </li>
        </ul>

        {/* Hamburger - Right */}
        <div className="md:hidden ml-auto">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-page focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`}>
        <ul className="flex flex-col space-y-3 mt-4 list-none">
          <li>
            <Link to="/" className="text-page hover:text-gray-300">
              Home
            </Link>
          </li>
          <li>
            <Link to="/archive" className="text-page hover:text-gray-300">
              Portfolio
            </Link>
          </li>
          <li>
            <Link to="/research" className="text-page hover:text-gray-300">
              Research
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-page hover:text-gray-300">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
